"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepListNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const utils_common_to_kebap_case_1 = __importDefault(require("@gcloud-npm/utils.common.to-kebap-case"));
/**
 * normalizador del modulo MODULO_CARACTERISTIC_CARDS
 * @param {object} fields
 * @returns
 */
const stepListNormalizer = (data) => {
    var _a, _b, _c, _d, _e, _f;
    try {
        let res = null;
        const title = ((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title) || ((_c = (_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.title);
        const listadoCards = ((_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.ListadoCaracteristicCard) || ((_f = (_e = data === null || data === void 0 ? void 0 : data[0]) === null || _e === void 0 ? void 0 : _e.fields) === null || _f === void 0 ? void 0 : _f.listadoCaracteristicas);
        if (listadoCards && Array.isArray(listadoCards) && listadoCards.length > 0) {
            const normalizedInfo = {};
            normalizedInfo.component = "stepList";
            if (title) {
                normalizedInfo["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
            }
            listadoCards.map((faq, index) => {
                const { fields } = faq;
                const { title, subTitle, icon } = fields;
                const card = {};
                if (icon) {
                    card["Glyph-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Glyph-1"]), { id: (0, utils_common_to_kebap_case_1.default)(icon) });
                }
                if (title) {
                    card["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-1"]), { text: title });
                }
                if (subTitle) {
                    card["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-2"]), { text: subTitle });
                }
                const hasItems = Object.keys(card).length > 0;
                if (hasItems) {
                    normalizedInfo[`Charac-${index}`] = card;
                }
            });
            res = normalizedInfo;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.stepListNormalizer = stepListNormalizer;
exports.default = exports.stepListNormalizer;
//# sourceMappingURL=index.js.map